import { toast } from 'vue-sonner'
import { quotesService } from '../../services/index.js'
import { CallResult } from '../../constants/commercial-call.js'

/**
 * Composable pour gérer les actions liées au statut des appels
 */
export function useCallStatus(callState, saveCall) {
  const sendAvailabilityRequest = async () => {
    const updateStatusFn = callState.callbacks.value.updateStatus
    const loadQuoteFn = callState.callbacks.value.loadQuote
    
    if (!confirm('Envoyer un email de demande de disponibilités au client ?\n\nL\'appel continuera en arrière-plan.')) {
      return
    }
    
    callState.sendingEmail.value = true
    try {
      await saveCall({ skipStatusUpdate: true, sendEmail: true, keepCallActive: true })
      await quotesService.sendAvailabilityRequest(callState.quoteId.value)
      
      if (updateStatusFn) {
        await updateStatusFn('appel_qualification')
      }
      toast.success('Email de demande de disponibilités envoyé avec succès')
      if (loadQuoteFn) {
        await loadQuoteFn()
      }
      
    } catch (err) {
      toast.error(err.message || 'Erreur lors de l\'envoi de l\'email')
      console.error(err)
    } finally {
      callState.sendingEmail.value = false
    }
  }

  const proposePhoneAppointment = async () => {
    const updateStatusFn = callState.callbacks.value.updateStatus
    const loadQuoteFn = callState.callbacks.value.loadQuote
    
    if (!confirm('Envoyer un email pour proposer un RDV téléphonique au client ?\n\nL\'appel continuera en arrière-plan.')) {
      return
    }
    
    callState.sendingEmail.value = true
    try {
      await saveCall({ skipStatusUpdate: true, sendEmail: true, keepCallActive: true })
      await quotesService.proposePhoneAppointment(callState.quoteId.value)
      
      if (updateStatusFn) {
        await updateStatusFn('appel_qualification')
      }
      toast.success('Email de proposition de RDV téléphonique envoyé avec succès')
      if (loadQuoteFn) {
        await loadQuoteFn()
      }
      
    } catch (err) {
      toast.error(err.message || 'Erreur lors de l\'envoi de l\'email')
      console.error(err)
    } finally {
      callState.sendingEmail.value = false
    }
  }

  const confirmNoAnswer = async () => {
    const updateStatusFn = callState.callbacks.value.updateStatus
    const loadQuoteFn = callState.callbacks.value.loadQuote
    const loadHistoryFn = callState.callbacks.value.loadHistory
    
    callState.showNoAnswerModal.value = false
    
    try {
      await saveCall({
        skipStatusUpdate: false,
        result: CallResult.NO_ANSWER,
        sendEmail: callState.sendEmailOnNoAnswer.value,
        keepCallActive: false,
        extra: {
          voicemail: callState.noAnswerVoicemail.value || undefined,
          noAnswerEmailVariant: callState.noAnswerEmailVariant.value || undefined,
          noAnswerCustomMessage: callState.noAnswerCustomMessage.value || undefined
        }
      })
      toast.success('Appel enregistré comme "Ne répond pas"')
      
      if (loadHistoryFn) {
        await loadHistoryFn()
      }
      if (loadQuoteFn) {
        await loadQuoteFn()
      }
    } catch (err) {
      // L'erreur est déjà gérée dans saveCall
    }
  }

  return {
    sendAvailabilityRequest,
    proposePhoneAppointment,
    confirmNoAnswer
  }
}
